import {
  MOBILE_VIEW_THRESHOLD_PX,
  ROUTE_LANDING,
  ROUTE_LOGIN,
  ROUTE_MOBILE_NUMBER,
  ROUTE_VERIFY_EMAIL,
} from '@1bill-app/constants';
import { environment } from '@1bill-app/env';
import { getReferralCodeFromLocalStorage, removeReferralCodeFromLocalStorage } from '@1bill-app/helpers/storage.helper';
import {
  AppsflyerService,
  UserRegistrationMethods,
} from '@1bill-app/services/analytics/appsflyer.service';
import { AuthQuery } from '@1bill-app/services/auth/state/auth.query';
import { AuthService } from '@1bill-app/services/auth/state/auth.service';
import { StorageItemKeys } from '@1bill-app/services/storage.service';
import { UserService } from '@1bill-app/services/user/user.service';
import { getValidationMsgs, ValidationMsgIF } from '@1bill-app/validators/messages';
import { Component, NgZone, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Facebook } from '@awesome-cordova-plugins/facebook/ngx';
import { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth/lib/types/Auth';
import { NavController, Platform } from '@ionic/angular';
import { NGXLogger } from 'ngx-logger';
import { map } from 'rxjs/operators';
import { SOCIAL_LOGIN_OPTS } from 'src/app/app.menu';
import { signUpForm } from './form';

const FederatedProvider = CognitoHostedUIIdentityProvider;

declare let fbq: any;

@Component({
  selector: 'app-create-account',
  templateUrl: './create-account.page.html',
  styleUrls: ['./create-account.page.scss'],
})
export class CreateAccountPage implements OnInit {
  currentPage: 'email' | 'password';

  constructor(
    private navCtrl: NavController,
    private logger: NGXLogger,
    private authService: AuthService,
    private authQuery: AuthQuery,
    private _zone: NgZone,
    private fb: Facebook,
    private appsflyerSvc: AppsflyerService,
    private platform: Platform,
    private userService: UserService,
  ) {
    this.currentPage = 'email';
    this.signUpForm = signUpForm();
    this.validationMsgs = getValidationMsgs();
  }

  signIn = ROUTE_LOGIN;
  landingPage = ROUTE_LANDING;
  routeMobileNumber = ROUTE_MOBILE_NUMBER;
  socialSignInOpts = SOCIAL_LOGIN_OPTS;
  signUpForm: FormGroup;
  public serverValidationError: string = null;
  // @ViewChild('emailInput', { static: false }) emailInput: IonInput;

  /* Flag property */
  public loading: boolean;
  public showValidationError = false;
  public showEmailValidationError = false;
  public socialLoading$ = this.authQuery.select('ui').pipe(map((ui) => ui.socialLoading));
  /* Ngmodel property */
  user: FormGroup;
  validationMsgs: ValidationMsgIF;
  appTerms = environment.appTerms;
  appPrivacyPolicy = environment.appPrivacyPolicy;
  password1Type: 'text' | 'password' = 'password';
  password2Type: 'text' | 'password' = 'password';
  /**
   * A referral code captured during signup. The user may enter the referral code after
   * signup, where they also enter their first and last name, but this improves user
   * experience after signing up with the app in case the user closes the browser
   * session and the local storage is cleared.
   */
  referralCode: string;

  get isDesktopView() {
    return this.platform.width() >= MOBILE_VIEW_THRESHOLD_PX;
  }
  get firstNameCtrl() {
    return this.signUpForm.get('firstName');
  }
  get lastNameCtrl() {
    return this.signUpForm.get('lastName');
  }
  get emailCtrl() {
    return this.signUpForm.get('email');
  }
  get passwordCtrl() {
    return this.signUpForm.get('matchingPasswords').get('password');
  }
  get confirmPasswordCtrl() {
    return this.signUpForm.get('matchingPasswords').get('confirmPassword');
  }
  async ngOnInit() {
    this.authService.clearAuthState();
  }

  ngOnDestroy(): void {
    this.signUpForm.reset();
  }

  get firstNameClass() {
    return (this.showValidationError &&
      this.firstNameCtrl.invalid &&
      this.firstNameCtrl.touched) ||
      this.serverValidationError
      ? 'error'
      : '';
  }
  get lastNameClass() {
    return (this.showValidationError &&
      this.lastNameCtrl.invalid &&
      this.lastNameCtrl.touched) ||
      this.serverValidationError
      ? 'error'
      : '';
  }
  get emailClass() {
    return (this.showEmailValidationError &&
      this.emailCtrl.invalid &&
      this.emailCtrl.touched) ||
      this.serverValidationError
      ? 'error'
      : '';
  }
  get pwdClass() {
    return (this.showValidationError &&
      this.passwordCtrl.invalid &&
      this.passwordCtrl.touched) ||
      this.serverValidationError
      ? 'error'
      : '';
  }
  get confirmPwdClass() {
    return (this.showValidationError &&
      this.confirmPasswordCtrl.invalid &&
      this.confirmPasswordCtrl.touched) ||
      this.serverValidationError
      ? 'error'
      : '';
  }

  onChangeForm() {
    if (this.currentPage === 'email') {
      this.showValidationError = false;
      this.serverValidationError = null;
    }
  }

  async onClickNext() {
    if (this.currentPage === 'email') {
      this.emailCtrl.markAsTouched();
      this.showEmailValidationError = true;
      if (!this.emailCtrl.valid) return;
      const email = this.emailCtrl.value;

      const isNotExists = await this.authService.checkEmailNotExists(email);

      this.logger.debug('email already registered: ', !isNotExists);

      if (!isNotExists) {
        this.showValidationError = true;
        this.serverValidationError = 'Email already registered';
        return;
      } else {
        this.showValidationError = false;
        this.serverValidationError = null;
      }

      this.currentPage = 'password';
    } else if (this.currentPage === 'password') {
      // HIDEREFERRALCODES
      // const referralCode = getReferralCodeFromLocalStorage();
      // if (referralCode?.length) {
      //   this.referralCode = referralCode;
      // }
      this.onClickSignup();
    // console.log(this.signUpForm.getRawValue());
    }
  }

  async onClickSignup() {
    // toggle validation flag
    this.showValidationError = true;
    this.signUpForm.markAllAsTouched();

    if (!this.signUpForm.valid) return;
    // get form values
    const email = this.emailCtrl.value;
    const password = this.passwordCtrl.value;
    // Submit referral code so that it can be used during the Cognito signup process,
    // registerUser API
    // HIDEREFERRALCODES
    // if (this.referralCode?.length) {
    //   // Clear for next sign-up attempt.
    //   this.loading = true;
    //   removeReferralCodeFromLocalStorage();
    //   await this.userService.submitReferralCode(email, this.referralCode).toPromise();
    // }
    this.loading = true;
    this.authService.signup({ email, password }).subscribe({
      next: (result) => {
        this.logger.debug('signup result: ', result);
        if (!result.userConfirmed && result.codeDeliveryDetails.DeliveryMedium === 'EMAIL') {
          this.signUpForm.reset();
          this.showValidationError = false;
          this.serverValidationError = null;
          this.navCtrl.navigateRoot(ROUTE_VERIFY_EMAIL);
        }
        this.loading = false;
      },
      error: (err) => {
        this.logger.error('onClickSignup', err);
        if (err.code && err.code === 'UsernameExistsException') {
          this.serverValidationError =
            err.message || 'An account with the given email already exists.';
        } else {
          this.serverValidationError = err.message;
        }
        this.loading = false;
      },
    });
  }

  onAppleSignin() {
    this._zone.run(async () => {
      this.authService.federatedSignIn(FederatedProvider.Apple).subscribe({
        next: () => {
          try {
            fbq('trackCustom', 'Sign Up');
            // track Facebook SDK event for native apps - Complete registration
            this.fb.logEvent('Complete registration', { registrationMethod: 'Apple' });
            // appsflyer
            this.appsflyerSvc.userRegistration(UserRegistrationMethods.APPLE);
          } catch (err) {
            this.logger.log(
              '[Apple Sign Up Event] Facebook Pixel tagging is not enabled in the current environment.',
            );
          }
        },
        error: this.handleError,
      });
    });
  }

  onFacebookSignin() {
    this._zone.run(async () => {
      this.authService.federatedSignIn(FederatedProvider.Facebook).subscribe({
        next: (a) => {
          try {
            fbq('trackCustom', 'Sign Up');
            // track Facebook SDK event for native apps - Complete registration
            this.fb.logEvent('Complete registration', { registrationMethod: 'Facebook' });
            // appsflyer
            this.appsflyerSvc.userRegistration(UserRegistrationMethods.FACEBOOK);
          } catch (err) {
            this.logger.log(
              '[Facebook Sign Up Event] Facebook Pixel tagging is not enabled in the current environment.',
            );
          }
        },
        error: this.handleError,
        complete: () => {
          this.logger.log('onFacebookSignin b');
        },
      });
    });
  }

  onGoogleSignin() {
    this._zone.run(async () => {
      this.authService.federatedSignIn(FederatedProvider.Google).subscribe({
        next: () => {
          try {
            fbq('trackCustom', 'Sign Up');
            // track Facebook SDK event for native apps - Complete registration
            this.fb.logEvent('Complete registration', { registrationMethod: 'Google' });
            // appsflyer
            this.appsflyerSvc.userRegistration(UserRegistrationMethods.GOOGLE);
          } catch (err) {
            this.logger.log(
              '[Google Sign Up Event] Facebook Pixel tagging is not enabled in the current environment.',
            );
          }
        },
        error: this.handleError,
      });
    });
  }

  handleError(err) {
    this.authService.clearProviderState();
    this.logger.error('socialSignIn', err);
  }

  togglePasswordType(controlIdentifier: number) {
    switch (controlIdentifier) {
      case 1:
        {
          this.password1Type = this.password1Type === 'text' ? 'password' : 'text';
        }
        break;
      case 2: {
        this.password2Type = this.password2Type === 'text' ? 'password' : 'text';
      }
    }
  }
}
